import React from 'react';
import { TextField, useFieldHelper, FieldProps } from 'framework/ui/field';

interface PerformanceMeasurementPercentileFieldProps extends FieldProps {
  value?: Nullable<string>;
  source?: Nullable<string>;
  label?: Nullable<string> | Nullable<JSX.Element>;
  width?: string;
}

const PerformanceMeasurementPercentileField = ({
  value: inputValue = null,
  source = null,
  label = null,
  width = '15%',
}: PerformanceMeasurementPercentileFieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });
  const value = inputValue || (getValue && getValue());

  const numberValue = Number.isNaN(Number(value)) ? Number(0.0) : Number(value);
  const normalizedValue = (Math.round(numberValue * 10) / 10).toFixed(1);

  return <TextField label={label} value={normalizedValue} width={width} />;
};

export default PerformanceMeasurementPercentileField;
